import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

import { store } from '@/store'

export const Route = createFileRoute('/_layout/_private/app/')({
  component: Outlet,
  loader: () => {
    if (!store.getState().isInitialized) {
      return null
    }

    if (!store.getState().isAuthorized) {
      throw redirect({
        to: '/login',
        search: {
          back_url: '/app/rewards',
        },

        replace: true,
      })
    }
    throw redirect({
      to: '/app/rewards',
      replace: true,
    })
  },
})
